import { genericResources } from './generic';
import { errorResources } from './errors';

const resources = {
  en: {
    translation: {
      ...genericResources.en,
      ...errorResources.en,
    },
  },
  el: {
    translation: {
      ...genericResources.el,
      ...errorResources.el,
    },
  },
};

export default resources;
